// extracted by mini-css-extract-plugin
export default {"mainContainer":"IconList_mainContainer__1ugVH","value":"IconList_value__REAsL"};